module.exports = __webpack_public_path__ + "img/calendar-3_fill.ce3f3206.svg";